import dayjs from "dayjs";
import { getBestPriceHorizontalCalendarAction } from "../../../../Actions/LogicActions/TrainOffer/GetBestPriceHorizontalCalendarAction";
import { getShuttleOfferBookAction } from "../../../../Actions/LogicActions/TrainOffer/GetShuttleOfferBookAction";
import { changeDateSelectorChangeAction } from "../../../../Actions/UIActions/ChangeDate/ChangeDateSelectorChangeAction";
import { dateSelectorChangeAction } from "../../../../Actions/UIActions/TrainOffer/DateSelectorChangeAction";
import { dateSelectorPrevNextAction } from "../../../../Actions/UIActions/TrainOffer/DateSelectorPrevNextAction";
import { dateSelectorUpdationAction } from "../../../../Actions/UIActions/TrainOffer/DateSelectorUpdationAction";
import { filterSelectorAction } from "../../../../Actions/UIActions/TrainOffer/FilterSelectorAction";
import { getLegsSummaryFromTripAction } from "../../../../Actions/UIActions/TrainOffer/GetLegsFromTripAction";
import { modifySearchAction } from "../../../../Actions/UIActions/TrainOffer/ModifySearchAction";
import { premiumTrainSelectAction } from "../../../../Actions/UIActions/TrainOffer/PremiumTrainSelectAction";
import { standardTrainSelectAction } from "../../../../Actions/UIActions/TrainOffer/StandardTrainSelectAction";
import { ticketTypeChangeAction } from "../../../../Actions/UIActions/TrainOffer/TicketTypeChangeAction";
import { trainListChangeAction } from "../../../../Actions/UIActions/TrainOffer/TrainListChangeAction";
import { trainListLoadMoreAction } from "../../../../Actions/UIActions/TrainOffer/TrainListLoadMoreAction";
import { trainSelectAction } from "../../../../Actions/UIActions/TrainOffer/TrainSelectAction";
import { KeyCloakService } from "../../../../Auth/KeyCloak";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { bookReturnJourneyTree, trainOfferEvtTree } from "../../../../Orchestrator/ConstantTree";
import { changeDateTree } from "../../../../Orchestrator/ConstantTree/ChangeDatePage/ChangeDateTree";
import { TrainTypeEnum } from "../../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { BackToBookingClickType, IBookingResponse, ShuttleOfferRequest, TrainListChangeType, TrainOfferDateSelector, TrainOfferDateSelectorType, TrainOfferRequest, TrainSelectionType } from "../../../../Orchestrator/Types/Index";
import { IGetBestPriceActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/CalendarBestPrice";
import { IGetLegsFromTripActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/TrainActions";
import { PriceInfo } from "../../../../Orchestrator/Types/Types/TrainTypes";
import { SearchContext } from "../../../Common/Search/Context/SearchContext";
import { SelectOfferContext } from "../Context/SelectOfferContext";
import { bookReturnJourneyDateChangeAction } from "../../../../Actions/UIActions/BookReturnJourney/BookReturnJourneyDateChangeAction";
import { backToBookingClickAction } from "../../../../Actions/UIActions/BookReturnJourney/BackToBookingClickAction";
import { getBookedPassesAction } from "../../../../Actions/LogicActions/CMSOffers/GetBookedPassesAction";
import { applyPassOfferForSinglePassengerAction } from "../../../../Actions/LogicActions/Booking/ApplyPassOfferForSinglePassengerAction";
import { IMultiplePassengerPassApplyActionParams, multiplePassengerPassApplyAction } from "../../../../Actions/UIActions/Booking/MultiplePassengerPassApplyAction";
import { IPassBooking } from "../../../../Orchestrator/Types/Types/BookingTypes";
import { getCachedCustomerTiers } from "../../../../app/api/getCustomerTiers";
import { getCachedTiersConfig } from "../../../../app/api/getCachedTiersConfig";
import { getRecoilStateValue } from "../../../../Orchestrator/Recoils/Events/Recoil";

class SelectOfferPageStep extends StepFlow {
    get stepName() { return "SelectOffer_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on<{ ticketType: string }, void>({
                eventName: trainOfferEvtTree.Offer.TrainType.Select,
                handler: (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.ticketType = payload.data?.ticketType!;
                    ticketTypeChangeAction.setParams({ ticketType: context.ticketType });
                    ticketTypeChangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: trainOfferEvtTree.Offer.ModifySearch.Click,
                handler: (payload) => {
                    modifySearchAction.setParams(payload.data!);
                    modifySearchAction.execute();

                    const selectOfferContext = this.getCtx<SelectOfferContext>("SelectOfferContext")!
                    selectOfferContext.routeTo = []
                    selectOfferContext.nextTo = ["SearchFlow"]
                    this.next()
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{
                date: string,
                fullDate: string,
                currentTrainType: string,
                dateSelectionState: [dayjs.Dayjs, dayjs.Dayjs],
                booking: IBookingResponse,
                selectedPassengerForCancel: string[]
            }, void>({
                eventName: bookReturnJourneyTree.BookReturnJourney.DateSelector.Change,
                handler: async (payload) => {
                    bookReturnJourneyDateChangeAction.setParams(payload.data!);
                    await bookReturnJourneyDateChangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<TrainOfferDateSelectorType, void>({
                eventName: trainOfferEvtTree.Offer.DateSelector.Click,
                handler: (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.trainOfferDateSelectorType = payload.data!;
                    dateSelectorPrevNextAction.setParams({ ...context.trainOfferDateSelectorType });
                    dateSelectorPrevNextAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<TrainOfferDateSelector, void>({
                eventName: trainOfferEvtTree.Offer.DateSelector.Change,
                handler: async (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    let searchContext = this.getCtx<SearchContext>("searchContext")!;
                    context.trainOfferDateSelector = payload.data!;
                    dateSelectorChangeAction.setParams({ ...context.trainOfferDateSelector });
                    await dateSelectorChangeAction.execute();
                    if (dateSelectorChangeAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        searchContext.offerResult = dateSelectorChangeAction.result || [];
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{
                date: string,
                fullDate: string,
                currentTrainType: string,
                dateSelectionState: [dayjs.Dayjs, dayjs.Dayjs],
                booking: IBookingResponse,
                selectedPassengerForCancel: string[],
                selectedPassengerForCancelInBound: string[]
            }, void>({
                eventName: changeDateTree.ChangeDate.DateSelector.Change,
                handler: async (payload) => {
                    changeDateSelectorChangeAction.setParams(payload.data!);
                    await changeDateSelectorChangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<TrainOfferDateSelectorType, void>({
                eventName: trainOfferEvtTree.Offer.DateSelector.Updation,
                handler: (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.trainOfferDateSelectorType = payload.data!;
                    dateSelectorUpdationAction.setParams({ ...context.trainOfferDateSelectorType });
                    dateSelectorUpdationAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ filterValue: string[] }, void>({
                eventName: trainOfferEvtTree.Offer.FilterSelector.Click,
                handler: (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.filterValue = payload.data?.filterValue || [];
                    filterSelectorAction.setParams({ filterValue: context.filterValue });
                    filterSelectorAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<TrainListChangeType, void>({
                eventName: trainOfferEvtTree.Offer.TrainList.Change,
                handler: async (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.trainListChangeType = payload.data!;
                    trainListChangeAction.setParams({ ...context.trainListChangeType });
                    await trainListChangeAction.execute();
                    if (trainListChangeAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        context.filteredTrains = trainListChangeAction?.result || []
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ visibleTrains: number }, void>({
                eventName: trainOfferEvtTree.Offer.TrainListLoadMore.Click,
                handler: async (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.visibleTrains = payload.data?.visibleTrains || 0;
                    trainListLoadMoreAction.setParams({ visibleTrains: context.visibleTrains });
                    await trainListLoadMoreAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ priceInfo: PriceInfo }, void>({
                eventName: trainOfferEvtTree.Offer.StandardTrainSelector.Select,
                handler: (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.standardPriceInfo = payload.data?.priceInfo!;
                    standardTrainSelectAction.setParams({ priceInfo: context.standardPriceInfo });
                    standardTrainSelectAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ priceInfo: PriceInfo }, void>({
                eventName: trainOfferEvtTree.Offer.PremiumTrainSelector.Select,
                handler: (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.premiumPriceInfo = payload.data?.priceInfo!;
                    premiumTrainSelectAction.setParams({ priceInfo: context.premiumPriceInfo });
                    premiumTrainSelectAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<TrainSelectionType, void>({
                eventName: trainOfferEvtTree.Offer.TrainSelector.Select,
                handler: async (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.trainSelectionType = payload.data!;
                    trainSelectAction.setParams({ ...context.trainSelectionType });
                    await trainSelectAction.execute();

                    if (trainSelectAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const params: IGetLegsFromTripActionParams = {
                            trip: context?.trainSelectionType?.selectedOfferTrip || {},
                            tripDirection: (payload.data?.type === TrainTypeEnum.outbound || payload.data?.type === TrainTypeEnum.inbound) ? payload.data.type : TrainTypeEnum.outbound,
                            trainLegsValue: payload.data?.trainLegsValue
                        }
                        await getLegsSummaryFromTripAction.setParams(params)
                        await getLegsSummaryFromTripAction.execute()
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IGetBestPriceActionParams, void>({
                eventName: trainOfferEvtTree.Offer.Calender.BestPrice,
                handler: async ({ data }) => {
                    if (data) {
                        getBestPriceHorizontalCalendarAction.setParams({
                            selectedTrip: data.selectedTrip,
                            calendarDayInterval: data.calendarDayInterval,
                            type: data?.type,
                            selectedRange: data.selectedRange,
                            isChangeDate: data?.isChangeDate,
                            changeDatePax: data?.changeDatePax,
                            exchangeBeforePrice: data?.exchangeBeforePrice
                        })
                        await getBestPriceHorizontalCalendarAction.execute()
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ShuttleOfferRequest, void>({
                eventName: trainOfferEvtTree.Offer.Shuttle.Click,
                handler: async (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.shuttleOfferRequest = payload.data!;
                    await getShuttleOfferBookAction.setParams({ ...context.shuttleOfferRequest });
                    await getShuttleOfferBookAction.execute();
                    if (getShuttleOfferBookAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data = getShuttleOfferBookAction.result!;
                        if (data.returnText === "success" && data.checkoutRedirect == true) {
                            /**
                             * This is because, from here checkout flow will start but if pathname is /checkout then orchestrator also start checkout flow 
                             * Now I have two time Checkout flow is running so to avoid it I set checkoutFromWithLogin true
                             * This flag will be used in orchestrator if it is true then it will not start checkout flow again
                            */
                            sessionStorage.setItem("checkoutFromWithLogin", "true")


                            // context.routeTo = []
                            // this.next()

                            if (payload.data!.isShuttleChangeDate) {
                                context.routeTo = ["CheckoutFlow"]
                                this.next()
                            }
                            else {
                                context.routeTo = []; // This exit Select OfFlow.
                                context.nextTo = ["CheckoutFlow"]; // This will start these four flow.
                                this.next()
                            }


                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/checkout",
                            })
                        }
                        else if (data.returnText === "needLogin") {
                            KeyCloakService.login();
                        }
                    }
                }
            })
        )

        /**
         * This ticket option click event required here,
         * Because from ticket option we also need to close select offer flow.
         * From ticket option we will start checkout flow
         * So before checkout we need to close SelectOfferFlow and TicketOptionFlow
         * We also have same @event trainOfferEvtTree.Offer.Continue.Click into TicketOptionFlow which is correct and main event
         * This is only for to close @flow SelectOfferFlow
         * This event also called when you click Continue on ticket option page.
        */
        this.registerEventSubscription(
            _eventBus.on<TrainOfferRequest, void>({
                eventName: trainOfferEvtTree.Offer.Continue.Click,
                handler: async (payload) => {
                    let context = this.getCtx<SelectOfferContext>("SelectOfferContext")!;
                    context.routeTo = []
                    this.next()
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<BackToBookingClickType, void>({
                eventName: changeDateTree.ChangeDate.BackToBookingClick,
                handler: async (data: any) => {
                    backToBookingClickAction.setParams(data.data!);
                    await backToBookingClickAction.execute();
                    // Also emit route change for immediate navigation
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/bookings/change-date",
                    });
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.BackToBookingClick,
                handler: async (data: any) => {
                    backToBookingClickAction.setParams(data.data!);
                    await backToBookingClickAction.execute();
                    // Also emit route change for immediate navigation
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/bookings",
                    });
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: trainOfferEvtTree.Offer.PassOffer.Get,
                handler: async (data: any) => {
                    getBookedPassesAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ passBooking: IPassBooking }, void>({
                eventName: trainOfferEvtTree.Offer.PassOffer.SinglePassenger.Change,
                handler: async (data: any) => {
                    const { passBooking } = data.data!;
                    if (passBooking) {
                        applyPassOfferForSinglePassengerAction.setParams({ passBooking: passBooking });
                        applyPassOfferForSinglePassengerAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IMultiplePassengerPassApplyActionParams, void>({
                eventName: trainOfferEvtTree.Offer.PassOffer.MultiPassenger.Apply,
                handler: async (data) => {
                    multiplePassengerPassApplyAction.setParams(data.data!);
                    multiplePassengerPassApplyAction.execute();
                }
            })
        )
    }


    async onExecute(): Promise<void> {
        console.log("SelectOffer step call.................................")

        // Pre-fetch loyalty tiers and tiers-config so they're cached
        // before the user clicks an offer (avoids delay on first selection)
        const isAnonymous = getRecoilStateValue<boolean>("isAnonymousStateAtom");
        if (!isAnonymous) {
            getCachedCustomerTiers().catch(() => {});
            getCachedTiersConfig().catch(() => {});
        }
    }

}
export const selectOfferPageStepDefinition = new StepDefinition({
    stepName: "SelectOffer_Step",
    stepClass: SelectOfferPageStep
});